<template>
  <!-- <footer class="">
    <div class="container margin_60_35">
      
      <div class="row">

        <div class="col-lg-12 text-center">
        <span>Copyright © {{this.date}} Course Manager. All rights reserved.</span>
        </div>
      </div>
    </div>
  </footer> -->


  <!-- footer begin -->
  <footer class="footer-light">
                <div class="container">
                    <div class="row justify-content-between">
                        <div class="col-lg-5 col-md-6 col-sm-6">
                            <div class="widget w-100">
                                <a href="index.html" class=""><img alt="" class="logo w-50 mb-2"
                                        src="assets/img/circleram-logo.png"></a>
                                        <!-- <p>Manage classes, webinars, library memberships CX</p> -->
                                        <p>The AI Platform for Education</p>
                            </div>
                        </div>

                        <div class="col-lg-2 col-md-3 col-sm-3">
                            <div class="widget">
                                <h5>Resources</h5>
                                <ul>

                                    <li><router-link to="/login">Support Request</router-link></li>
                                    <li><router-link to="/blog">Blog</router-link></li>
                                    <li><router-link to="/faq">FAQ</router-link></li>
                                    <li><router-link to="/release">Release Note</router-link></li>
                                    <li><router-link to="/tutorials">Tutorial</router-link></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-3 col-sm-3">
                            <div class="widget">
                                <h5>Company</h5>
                                <ul>
                                    <li><a href="https://circleram.com/aboutus.aspx">About</a></li>
                                    <li><router-link to="/news">Press</router-link></li>
                                    <li><a href="https://circleram.com/contact.aspx">Contact</a></li>
                                </ul>
                            </div>
                        </div>


                        <div class="col-lg-3 col-md-6 text-right">
                            <div class="widget">
                                <h5 class="d-none">Subscribe</h5>
                                <div class="input-group mb-3 d-none">
                                    <input id="subscribe-email" type="text" class="form-control" placeholder="Enter your email" aria-label="Email" aria-describedby="subscribe-email">
                                    <div class="input-group-append">
                                        <button class="btn btn-dark" type="button" id="submit-subscribe-email"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                                <!-- <div class="social-icons mt-3"> -->
                                <div class="social-icons">
                                    <a href="https://www.facebook.com/circleram2" target="_blank"><i class="fa fa-facebook fa-lg"></i></a>
                                    <a href="https://x.com/Circleram2?prefetchTimestamp=1724411475303"><i class="fa fa-twitter fa-lg" target="_blank"></i></a>
                                    <a href="https://www.linkedin.com/company/circleram/about/" target="_blank"><i class="fa fa-linkedin fa-lg" target="_blank"></i></a>
                                    <!-- <a href="#"><i class="fa fa-instagram fa-lg" target="_blank"></i></a> -->
                                    <a href="https://www.youtube.com/channel/UCSyBtSk3P0c_rpi_hHRMl1A" target="_blank"><i class="fa fa-play fa-lg" target="_blank"></i></a>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-8 sm-text-center mb-sm-30">
                            <div class="mt10"> <a class="">Copyright © {{ new Date().getFullYear() }} - circleram- A project of in-school.com inc. All rights reserved</a>
                            </div>
                        </div>

                        <div class="col-md-4 text-md-right text-sm-left">
                            <div class="social-icons">
                                <a href="https://circleram.com/terms.aspx" class="mr-2" target="_blank">Terms</a>
                                <a href="https://circleram.com/privacy.aspx" class="mr-2" target="_blank">Privacy</a>  
                                <a href="#" class="mr-2 d-none">Cookie Declaration</a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <!-- footer close -->

  
  <!--/footer-->
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      date: new Date().getFullYear()
    }
  }
}
</script>
